import { createAction } from 'redux-actions';
import { createDeferredAction, createTypedAction } from '../../utils/redux';
import { CENTRIFUGE_MODULE } from '../../configs/moduleNames';
import { CONNECTING, FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const CENTRIFUGE_CONNECTION = '_CENTRIFUGE_CONNECTION';
export const CENTRIFUGE_DISCONNECTION = '_CENTRIFUGE_DISCONNECTION';
export const ON_MESSAGE = '_ON_MESSAGE';
export const CENTRIFUGE_PUBLICATION = '_CENTRIFUGE_PUBLICATION';
export const GET_CENTRIFUGE_TOKEN = '_GET_CENTRIFUGE_TOKEN';
export const TRACKING_SUBSCRIBE = '_TRACKING_SUBSCRIBE';
export const SUBSCRIBE = '_SUBSCRIBE';
export const UNSUBSCRIBE = '_UNSUBSCRIBE';
export const SEND_TRACKING_REFRESH = '_SEND_TRACKING_REFRESH';

export const centrifugeConnection = createDeferredAction(CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION);
export const centrifugeDisconnection = createDeferredAction(CENTRIFUGE_MODULE + CENTRIFUGE_DISCONNECTION);
export const centrifugeConnectionSuccessful = createAction(CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION + SUCCESSFUL);
export const centrifugeConnectionFailed = createAction(CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION + FAILED);
export const centrifugeConnectionConnecting = createAction(CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION + CONNECTING);
export const centrifugeSubscribe = createDeferredAction(CENTRIFUGE_MODULE + SUBSCRIBE);
export const centrifugeSubscribeSuccessful = createAction(CENTRIFUGE_MODULE + SUBSCRIBE + SUCCESSFUL);
export const centrifugeSubscribeFailed = createAction(CENTRIFUGE_MODULE + SUBSCRIBE + FAILED);
export const centrifugeUnsubscribe = createDeferredAction(CENTRIFUGE_MODULE + UNSUBSCRIBE);
export const centrifugePublication = createTypedAction(CENTRIFUGE_MODULE + CENTRIFUGE_PUBLICATION);

export const getCentrifugeToken = createDeferredAction(CENTRIFUGE_MODULE + GET_CENTRIFUGE_TOKEN);
export const getCentrifugeTokenSuccessful = createAction(CENTRIFUGE_MODULE + GET_CENTRIFUGE_TOKEN + SUCCESSFUL);
export const getCentrifugeTokenFailed = createAction(CENTRIFUGE_MODULE + GET_CENTRIFUGE_TOKEN + FAILED);

export const trackingSubscribe = createDeferredAction(CENTRIFUGE_MODULE + TRACKING_SUBSCRIBE);
export const trackingSubscribeSuccessful = createAction(CENTRIFUGE_MODULE + TRACKING_SUBSCRIBE + SUCCESSFUL);
export const trackingSubscribeFailed = createAction(CENTRIFUGE_MODULE + TRACKING_SUBSCRIBE + FAILED);

export const sendTrackingRefresh = createDeferredAction(CENTRIFUGE_MODULE + SEND_TRACKING_REFRESH);
export const sendTrackingRefreshSuccessful = createAction(CENTRIFUGE_MODULE + SEND_TRACKING_REFRESH + SUCCESSFUL);
export const sendTrackingRefreshFailed = createAction(CENTRIFUGE_MODULE + SEND_TRACKING_REFRESH + FAILED);
